import type { HelpFile } from '../../types/help'
import { ProvisioningTestIds } from '../../../testids/ProvisioningTestIds'

export const provisioningHelp: HelpFile = {
  docPage: '/docs/provisioning/overview',
  texts: {
    [ProvisioningTestIds.provisioningWelcomeCard]:
      'Provisioning section landing page — pick a tool from the sidebar: dashboard, tasks queue, and task history.',
  },
}
